export default "__VITE_ASSET__c91c298d__"